import { DecisionEnvironment } from "src/api/types";
import { Button } from "src/design-system/Button";
import { Tooltip } from "src/design-system/Tooltip";
import { useRunJobActionButton, useRunJobHandler } from "src/jobs/common/hooks";
import { RunJobModal } from "src/jobs/common/RunJobModal";
import { Job } from "src/jobs/types";

export const RunButton: React.FC<{
  job: Job;
}> = ({ job }) => {
  const handler = useRunJobHandler(job);
  const actionButton = useRunJobActionButton(job, handler);

  if (!actionButton) return null;

  const { label, dataLoc, isDisabled, onClick, tooltip } = actionButton;
  const button = (
    <Button
      dataLoc={dataLoc}
      isDisabled={isDisabled}
      size="sm"
      variant="secondary"
      onClick={onClick}
    >
      {label}
    </Button>
  );

  return (
    <>
      {tooltip ? (
        <Tooltip {...tooltip} asChild>
          {button}
        </Tooltip>
      ) : (
        button
      )}
      <RunJobModal
        afterLeave={handler.afterLeave}
        closeModal={handler.closeModal}
        env={
          job.status === "active"
            ? DecisionEnvironment.LIVE
            : DecisionEnvironment.SANDBOX
        }
        isOpen={handler.isOpen}
        job={job}
        onConfirm={handler.onConfirm}
      />
    </>
  );
};
